<template>
  <div class="content">
    <div class="set_wrap">
      <el-form ref="form" :model="formdata" label-width="220px">
        <el-form-item label="发货后多长时间自动确认收货" prop="day">
          <el-input v-model.number="formdata.auto_confirm" class="w80"></el-input>&nbsp;&nbsp;天
        </el-form-item>
        <el-form-item label="待付款的订单多长时间自动取消" prop="day">
          <el-input v-model.number="formdata.auto_clear" class="w80"></el-input>&nbsp;&nbsp;分
          <p class="prompt_infor">没有配置过的使用默认值，发货后15天自动收货，创建订单30分钟内没有付款自动取消</p>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";
export default {
  name: "orderSettings",
  data() {
    return {
      formdata: {
        auto_confirm: "",
        auto_clear: ""
      }
    };
  },
  created() {
    this.queryconfig();
  },
  methods: {
    // 查询配置
    queryconfig() {
      let params = {};
      this.axios
          .post(api.shopconf_order_conf_index, params)
          .then(response => {
            if (response.data.code == 0) {
              this.formdata.auto_confirm = response.data.info.auto_confirm;
              this.formdata.auto_clear = response.data.info.auto_clear;
            } 
          })
          .catch(response => {
          });
    },
   save(){
      this.axios
          .post(api.shopconf_conf_edit, this.formdata)
          .then(response => {
            if (response.data.code == 0) {
              this.$message.success("保存成功");
            } 
          })
          .catch(response => {
          });
   }
  }
};
</script>

<style scoped>
.set_wrap{-webkit-box-shadow: none; box-shadow: none;}
</style>